"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _NavigationLink = _interopRequireDefault(require("./NavigationLink"));

var _classnames = _interopRequireDefault(require("classnames"));

var NavigationBlock = function NavigationBlock(_ref) {
  var currentCategory = _ref.currentCategory,
      categories = _ref.categories,
      pathToCategory = _ref.pathToCategory,
      showBorder = _ref.showBorder,
      expandedCategories = _ref.expandedCategories,
      toggleCategory = _ref.toggleCategory;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('category-sidebar-navigation__block', {
      'category-sidebar-navigation__block--show-border': showBorder
    })
  }, categories.map(function (category) {
    var categoryId = category.id,
        title = category.title,
        children = category.children,
        isContainer = category.isContainer,
        url = category.url;
    var isCurrent = currentCategory === categoryId;
    var hasChildren = Boolean(children.length);
    var isExpanded = expandedCategories.includes(categoryId);
    return (0, _preact.h)("div", {
      className: "category-sidebar-navigation__block-item",
      key: "category-id-".concat(categoryId)
    }, (0, _preact.h)("div", {
      className: "category-sidebar-navigation__header"
    }, (0, _preact.h)(_NavigationLink.default, {
      url: url,
      isCurrent: isCurrent,
      contentLevel: !isContainer,
      toggleCategory: toggleCategory,
      categoryId: categoryId,
      isExpanded: isExpanded,
      hasChildren: hasChildren
    }, title)), hasChildren && expandedCategories.includes(categoryId) && (0, _preact.h)(NavigationBlock, {
      categories: children,
      currentCategory: currentCategory,
      pathToCategory: pathToCategory,
      expandedCategories: expandedCategories,
      toggleCategory: toggleCategory
    }));
  }));
};

var _default = NavigationBlock;
exports.default = _default;